export default __webpack_public_path__ + "static/media/usa-star-2x.b150b0e8.png";